import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import OAPConfigurationForm from './OAPConfigurationForm';

// This is a wrapper class that allows placing the OAP Configuration
// form in any part of the website, providing a standalone connection
// to redux
const OAPConfigurationFormStandalone = props => (
  <Provider store={store}>
    <OAPConfigurationForm {...props} />
  </Provider>
);

export default OAPConfigurationFormStandalone;
